import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-slash",
  "use": "icon-slash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-slash\" id=\"icon-slash\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><line x1=\"4.93\" y1=\"4.93\" x2=\"19.07\" y2=\"19.07\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol